module.exports = __webpack_public_path__ + "static/media/sidebar.f94f5664.png";